// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"66738ce5","456":"f0487ae8","682":"00d44151"}[chunkId] + ".chunk.js";
};